import initDialog from '../initDialog'

import { RemoveDialog } from '../RemoveDialog'

import api from '../../../configs/api'

const styles = () => ({});

class RemoveTechnicianDialog extends RemoveDialog
{
    getLocale = () => this.props.locale.dialogs.application.technician.remove ;
}

RemoveTechnicianDialog.defaultProps =
{
    ...RemoveDialog.defaultProps,
    uri    : api.technicians.url,
    useUrl : true
};

RemoveTechnicianDialog.propTypes =
{
    ...RemoveDialog.propTypes
};

export default initDialog({ styles })( RemoveTechnicianDialog );
